var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.95833 8.7879L5.54167 7.20456L9.89583 11.5587L12.6667 8.7879L15.0417 11.1629V3.95833H3.95833V8.7879ZM3.16667 2.375H15.8333C16.2706 2.375 16.625 2.72945 16.625 3.16667V15.8333C16.625 16.2706 16.2706 16.625 15.8333 16.625H3.16667C2.72945 16.625 2.375 16.2706 2.375 15.8333V3.16667C2.375 2.72945 2.72945 2.375 3.16667 2.375ZM12.2708 7.91667C11.615 7.91667 11.0833 7.38501 11.0833 6.72917C11.0833 6.07333 11.615 5.54167 12.2708 5.54167C12.9267 5.54167 13.4583 6.07333 13.4583 6.72917C13.4583 7.38501 12.9267 7.91667 12.2708 7.91667Z",
    fill: "#969CA6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg);
export default __webpack_public_path__ + "static/media/img.878302fa2e4272323a5cb8f3cc0b1ffe.svg";
export { ForwardRef as ReactComponent };